import { useMemo } from 'react';
import { PayBenchmarkingOutput } from 'libs/end-to-end/src/pay-benchmarking';
import { CustomVizHookStatus } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { CustomVizHookResult } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { PayBenchmarkingState } from 'apps/sigma2-ui/src/pay-benchmarking/components/types';

export const usePayBenchmarkingCurrentState = ({
  status,
  result,
}: {
  result: CustomVizHookResult;
  status: CustomVizHookStatus;
}): PayBenchmarkingState => {
  return useMemo<PayBenchmarkingState>(() => {
    if (result.resultType === 'err' && status === 'waiting-for-user') {
      return {
        state: 'error_state',
      };
    }

    if (status === 'loading-viz') {
      return {
        state: 'loading_state',
      };
    }

    if (result.resultType === 'ok' && result.value === null) {
      return {
        state: 'empty_state',
      };
    }

    const parseResult = PayBenchmarkingOutput.safeParse(
      result.resultType === 'ok' && result.value,
    );

    if (parseResult.success) {
      return {
        state: 'success',
        output: parseResult.data,
      };
    } else {
      return {
        state: 'error_state',
      };
    }
  }, [result, status]);
};
